import { FC, useContext } from 'react';
import ComingSoon from './ComingSoon';
import WelcomeToMaps from './WelcomeToMaps';
import { MapPageWrapper } from './MyMap.styled';
import { UserContext } from 'context/UserContext';
import { CenterAlignedLoader } from '@medly-components/core';
import { MAP_ASSIGNMENT_STATUS } from 'pages/Home/components/features/Maps/utils';
import RequestMap from './RequestMap';
import { useMapStatus } from 'hooks/user/useMapStatus';

export const MyMap: FC = () => {
    const { user } = useContext(UserContext);
    const { status, isLoading } = useMapStatus();

    if (!user || isLoading || !status) {
        return (
            <main>
                <CenterAlignedLoader />
            </main>
        );
    }

    if (user.assignedRegions?.length) {
        return (
            <MapPageWrapper>
                <WelcomeToMaps />
            </MapPageWrapper>
        );
    }

    if (status === MAP_ASSIGNMENT_STATUS.NOT_ASSIGNED) {
        return (
            <MapPageWrapper>
                <RequestMap />
            </MapPageWrapper>
        );
    }

    return (
        <MapPageWrapper>
            <ComingSoon />
        </MapPageWrapper>
    );
};

MyMap.displayName = 'MyMap';
